export default "__VITE_ASSET__2a7b4894__"